import { render, staticRenderFns } from "./product-usps.vue?vue&type=template&id=497a1330&"
import script from "./product-usps.vue?vue&type=script&lang=js&"
export * from "./product-usps.vue?vue&type=script&lang=js&"
import style0 from "./product-usps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports